import { createAction } from 'redux-actions'

export const clearAccount = createAction('CLEAR_ACCOUNT')
export const clearAllMemberships = createAction('CLEAR_ALL_MEMBERSHIPS')
export const clearMembership = createAction('CLEAR_MEMBERSHIP')
